<template>
    <QualityChecklist></QualityChecklist>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const QualityChecklist = defineAsyncComponent(() =>
    import("../../components/CNC/QualityChecklist/QualityChecklist.vue")
);

export default {
    name: "Machine_QualityChecklist", //The name you are in should not equal the name of the component you are importing.
    components: { QualityChecklist, AuthLayout },
};
</script>
